import React, {useEffect, useState } from "react";
import { FaFacebookF, FaInstagram, FaYoutube } from "react-icons/fa";
import axios from "axios";
import { Link } from "react-router-dom";

export default function Footer() {

const [categories, setCategories] = useState([]);


  const API_URL = process.env.REACT_APP_API_URL;

  useEffect(() => {
    axios
      .get(API_URL + "categories")
      .then((res) => {
        setCategories(res.data);
      })
      .catch((err) => {
        console.error("Failed to load categories", err);
      });
  }, []);

  return (
    <footer style={{ background: "rgb(249, 249, 249)",borderTop:"1px solid rgb(245 245 245)", color: "#000" }} className="pt-5 pb-4">
      <div className="container">

        {/* Top Section */}
        <div className="row">

          {/* LEFT SIDE: Logo + Social */}
          <div className="col-md-4 mb-4">
            <img src="/logo-footer.png" width="250" alt="Logo" className="mb-3" />

            <div className="d-flex gap-3 mt-3">
              <a href="#" style={{ color: "#d3af34" }}>
                <FaFacebookF size={20} />
              </a>
              <a href="#" style={{ color: "#d3af34" }}>
                <FaInstagram size={20} />
              </a>
              <a href="#" style={{ color: "#d3af34" }}>
                <FaYoutube size={22} />
              </a>
            </div>
          </div>
           <div className="col-md-4 mb-4">
            <h5>Available Categories</h5>
            <ul style={{listStyle:"none",paddingLeft:"0px"}}>
                {categories.map((cat) => (
                  <li className="nav-item" key={cat.id}>
                    <Link className="nav-link" to={`/categories/${cat.slug}`}>
                      {cat.name.toLowerCase().replace(/\b\w/g, char => char.toUpperCase())}
                      <i className="glyphicon glyphicon-angle-right"></i>
                    </Link>
                  </li>
                  
                ))}
            </ul>
         
          </div>
           <div className="col-md-4 mb-4">
            <h5>Get In Touch</h5>
           <a href="mailto:info@brooksroyale.com" className="footer-link">info@brooksroyale.com</a>
         
          </div>


        

        </div>

        {/* Bottom Section */}
        <div
          className="pt-3 mt-4 text-center"
          style={{
            borderTop: "1px solid rgb(82,82,82)"
          }}
        >
          <p className="mb-1" style={{ fontSize: "14px" }}>
            © 2026 Brooksroyale — All rights reserved
          </p>

          <div>
            <a href="#" className="text-decoration-none text-light me-3" style={{ fontSize: "14px" }}>
              Terms of Use
            </a>
            <a href="#" className="text-decoration-none text-light" style={{ fontSize: "14px" }}>
              Privacy Policy
            </a>
          </div>
        </div>

      </div>
    </footer>
  );
}
